<div class="storefront-shimmer">
  <!-- Banner Skeleton -->
  <div class="storefront-banner">
    <app-skeleton
      height="15.00vh"
      width="	30.47vw"
      borderRadius="0.625vw "
    ></app-skeleton>
  </div>

  <div class="storefront-line">
    <app-skeleton
      height="2.87vh"
      width="30.47vw"
      borderRadius="0.625vw "
    ></app-skeleton>
  </div>

  <div class="storefront-line2">
    <app-skeleton
      height="6.67vh"
      width="27.19vw"
      borderRadius="0.625vw "
    ></app-skeleton>
  </div>

  <div class="storefront-line3">
    <app-skeleton
      height="10.65vh"
      width="30.47vw"
      borderRadius="0.625vw "
    ></app-skeleton>
  </div>

  <!-- Repeating Card Skeletons -->
  <div class="storefront-vertical-items">
    <div class="vertical-row horizontal-ac"
      *ngFor="let row of [[1,2,3,4,5,6,7]]; let i = index; trackBy: trackByIndex">
      <app-skeleton *ngFor="let key of row; let j = index; trackBy: trackByIndex" class="storefront-card"
      [class.is-last-card]="j === row.length - 1"
       height="32.78vh"
       width="12.29vw"
       borderRadius="1vw"
      ></app-skeleton>
    </div>
  </div>

</div>
